import React from 'react';
import { Link } from 'react-router-dom';
import { Star, Clock, Users, ArrowRight, Sparkles } from 'lucide-react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { useApp } from '../../context/AppContext';

const FeaturedTours = () => {
  const { tours } = useApp();
  const featuredTours = tours.slice(0, 6);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end gap-6 mb-16">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <Sparkles className="h-5 w-5 text-amber-500" />
              <span className="text-amber-600 font-semibold text-sm uppercase tracking-wider">Featured</span>
            </div>
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
              Popular Adventures
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl">
              Our most loved experiences, handpicked for unforgettable memories.
            </p>
          </div>
          <Link to="/trekking">
            <Button variant="outline" className="border-emerald-200 text-emerald-700 hover:bg-emerald-50">
              View All Tours
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {featuredTours.map((tour) => (
            <Link
              key={tour.id}
              to={`/tour/${tour.id}`}
              className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100"
            >
              {/* Image */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={tour.coverImage}
                  alt={tour.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                
                {/* Badges */}
                <div className="absolute top-4 left-4 flex gap-2">
                  <Badge className="bg-emerald-500 text-white hover:bg-emerald-600">
                    {tour.difficulty}
                  </Badge>
                </div>
                
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 group-hover:text-emerald-600 transition-colors mb-2">
                  {tour.name}
                </h3>
                <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                  {tour.shortDesc}
                </p>

                <div className="flex items-center justify-between text-sm text-gray-500">
                  <div className="flex items-center gap-4">
                    <span className="flex items-center gap-1">
                      <Clock className="h-4 w-4 text-emerald-500" />
                      {tour.duration}
                    </span>
                    <span className="flex items-center gap-1">
                      <Users className="h-4 w-4 text-emerald-500" />
                      {tour.groupSize}
                    </span>
                  </div>
                  <span className="flex items-center gap-1">
                    <Star className="h-4 w-4 text-amber-500 fill-amber-500" />
                    {tour.rating}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedTours;
